import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar  from './components/Navbar';
import Footer  from './components/Footer';
import Cursor  from './components/Cursor';

import Home    from './pages/Home';
import About   from './pages/About';
import RD      from './pages/RD';
import Team    from './pages/Team';
import News    from './pages/News';
import Careers from './pages/Careers';
import Contact from './pages/Contact';

// Scroll to top on route change
function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout() {
  return (
    <>
      <Cursor />
      <Navbar />
      <ScrollTop />
      <Routes>
        <Route path="/"        element={<Home />}    />
        <Route path="/about"   element={<About />}   />
        <Route path="/rd"      element={<RD />}      />
        <Route path="/team"    element={<Team />}    />
        <Route path="/news"    element={<News />}    />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}
